<template>
  <div
    class="table-content"
    :style="{ height: tableData.options.tableHeight + 'px' }"
  >
    <el-table
      :data="tableData.list"
      border
      fit
      :max-height="tableData.options.tableHeight"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <!-- 暂无数据提示，自己定义就OK了 -->
      <template slot="empty">
        <div class="empty-box">
          <i class="crm-wu icon"></i>
          <p class="col-66 text-1">
            {{
              tableData.options.errortip != ""
                ? tableData.options.errortip
                : $t("Common.empty_tips")
            }}
          </p>
        </div>
      </template>
      <el-table-column
        v-if="tableData.options.mutiSelect"
        type="selection"
        align="center"
        style="width: 55px"
        fixed="left"
      ></el-table-column>
      <!-- 表格数据渲染 -->
      <template v-for="(column, $index) in tableData.columns">
        <!-- 固定列 -->
        <template
          v-if="$index == IndexId || $index == IndexIdTwo || $index == 0"
        >
          <el-table-column
            :prop="column.fieldname"
            :key="$index"
            fixed="left"
            :show-overflow-tooltip="true"
            :sortable="column.sortable"
            :label="column.fieldstring"
            align="center"
            min-width="150px"
            v-if="column.show == '1'"
          >
            <template slot-scope="scope">
              <el-switch
                @change="switchChange(scope, scope.$index)"
                active-value="100"
                inactive-value="0"
                active-color="#F78F0E"
                v-if="column.isswitch == '1'"
                v-model="tableData.list[scope.$index][column.fieldname]"
              ></el-switch>
              <el-button
                v-else-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, column, scope.row)"
              >
                {{ tableData.list[scope.$index][column.fieldname] }}
              </el-button>
              <template v-else-if="column.istag == '1'">
                <el-tag
                  class="tag-sty"
                  v-for="(item, index) in tableData.list[scope.$index][
                    column.fieldname
                  ]"
                  :key="index"
                >
                  {{ item }}
                </el-tag>
              </template>
              <span v-else>
                {{ tableData.list[scope.$index][column.fieldname] }}
              </span>
            </template>
          </el-table-column>
        </template>
        <!-- 一般列 -->
        <template v-else>
          <el-table-column
            :prop="column.fieldname"
            :key="$index"
            :label="column.fieldstring"
            :sortable="column.sortable"
            align="center"
            :show-overflow-tooltip="true"
            min-width="150px"
            v-if="column.show == '1'"
          >
            <template slot-scope="scope">
              <template v-if="column.diyCotnent == 1">
                <slot
                  name="diy-slot"
                  :scope="{ row: scope.row, column: scope.column }"
                ></slot>
              </template>
              <el-switch
                @change="switchChange(scope.row, scope.$index)"
                active-value="100"
                inactive-value="0"
                active-color="#F78F0E"
                v-else-if="column.isswitch == '1'"
                v-model="tableData.list[scope.$index][column.fieldname]"
              ></el-switch>
              <el-switch
                @change="switchChange(scope.row, scope.$index)"
                active-value="1"
                inactive-value="0"
                active-color="#00A7D5"
                v-else-if="column.switch"
                v-model="tableData.list[scope.$index][column.fieldname]"
              ></el-switch>
              <el-button
                v-else-if="column.ismethod"
                type="text"
                class="link-type"
                @click="handleColumnChange(scope.$index, column, scope.row)"
              >
                {{ tableData.list[scope.$index][column.fieldname] }}
              </el-button>
              <template v-else-if="column.istag == '1'">
                <el-tag
                  class="tag-sty"
                  v-for="(item, index) in tableData.list[scope.$index][
                    column.fieldname
                  ]"
                  :key="index"
                >
                  {{ item }}
                </el-tag>
              </template>
              <span v-else>
                {{ tableData.list[scope.$index][column.fieldname] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
      <!-- 操作列 -->
      <slot></slot>
      <!-- 编辑列 -->
      <el-table-column
        fixed="right"
        label
        align="center"
        width="40px"
        v-if="tableData.options.issetting"
        :render-header="renderHeader"
      ></el-table-column>
    </el-table>
    <!-- 穿梭框 -->
    <el-dialog
      title="编辑列"
      class="setting-box"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-transfer
        v-model="showColumns"
        :data="data"
        :titles="['已显示列', '未显示列']"
      ></el-transfer>
      <div class="oprate">
        <el-button size="small" type="primary" @click="handSetting()">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "switchTableCont",
  props: {
    // 表格数据所有参数
    tableData: {
      type: Object,
    },
  },
  data() {
    return {
      dialogVisible: false,
      showColumns: [],
      data: [],
      IndexId: -1, //固定的列数
      IndexIdTwo: -1, //固定的列数
    };
  },
  created() {
    this.getColums();
  },
  watch: {
    getIndex(n) {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (n.length >= 8) {
        n.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
    },
  },
  computed: {
    getIndex() {
      return this.tableData.columns;
    },
  },
  methods: {
    getColums() {
      var i = 0;
      var _index = 0,
        _index_two = 0;
      if (this.tableData.columns.length >= 8) {
        this.tableData.columns.forEach((item, index) => {
          if (item.show == "1" && i == 0) {
            i++;
            _index = index;
          } else if (item.show == "1" && i == 1) {
            i++;
            _index_two = index;
          }
        });
        this.IndexId = _index;
        this.IndexIdTwo = _index_two;
      }
    },
    // 复选框控制权限
    checkboxInit() {
      // row, index
      return 0; //不可勾选
    },
    // 编辑列渲染
    renderHeader(h, { column, $index }) {
      (() => {})(h, column, $index);
      return h("span", {
        class: "mh-sz btn-setting",
        on: {
          click: () => {
            this.dialogVisible = true;
          },
        },
      });
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    handleColumnChange(k, v, column) {
      this.$emit("handleColumnChange", k, v, column);
    },
    handSetting() {
      this.$emit("handSetting", this.showColumns);
    },
    switchChange(v1, v2) {
      this.$emit("switchChange", v1, v2);
    },
  },
};
</script>
<style lang="less">
.btn-setting {
  display: block;
  width: 20px;
  height: 20px;
  font-size: 16px;
  margin: 0 auto;
  color: #aaa;
  // background-color: green;
  cursor: pointer;
}
</style>
